'use strict'

import angular from 'angular';
import moment from 'angular-moment';
import MathUtil from '../../math_util/math_util';

class DemandPredictionLogic {
  constructor(moment, MathUtil) {
    'ngInject';

    this.moment = moment;

    this.predict = (baseTime, instPowers) => {
      if(instPowers.length < 2) { return null; }

      let lastPower = instPowers[instPowers.length - 1];
      let lastPowerTime   = moment(lastPower.x);
      let demandStartTime = moment(baseTime);
      let demandEndTime   = demandStartTime.clone().add(30, 'minutes');
      
      let span = this.calcSpan(demandStartTime, lastPower.x);
      let targetValue = this.findTargetPower(instPowers, lastPowerTime.clone().subtract(span, 'seconds'));

      if(targetValue === null) { return null; }
      
      let averageForSecond = (MathUtil.subtract(lastPower.y, targetValue))/span;

      return lastPower.y + (averageForSecond * (demandEndTime.diff(lastPowerTime, 'seconds')));
    }
  }

  calcSpan(start, last) {
    if (this.moment(last).diff(this.moment(start), 'seconds') > 1200) {
      return 120;
    } else {
      return 180;
    }
  }

  // 実際のデータは時刻が数秒ずれるため、margin を取って抽出し、その平均値を探索結果とする。
  findTargetPower(powers, targetTime) {
    let findMargin = this.moment.duration(70, 'seconds');
    let lower = targetTime.clone().subtract(findMargin);
    let upper = targetTime.clone().add(findMargin);

    let target = null;
    let filteredPowers = powers.filter(power => {
      return this.moment(power.x).isBetween(lower, upper);
    });

    if(filteredPowers.length === 0){
      return null;
    }

    return (filteredPowers[0].y + filteredPowers[filteredPowers.length - 1].y) / 2;
  }
}

export default angular.module('leptonApp.DemandPredictionLogic', [moment, MathUtil])
  .service('DemandPredictionLogic', ['moment', 'MathUtil', DemandPredictionLogic])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/logic/prediction/demand_prediction/demand_prediction_logic.js